import { axiosInstance } from 'network/apis';

export const createProjectRequest = async (payload) => {
    payload.clientId = 1
    payload.moderatorBuffer = 15
  return await axiosInstance.post(`project/create-project`, payload, { handlerEnabled: true })
  
};

export default {
    createProjectRequest
};
